<div class="row" *ngIf="viewType != 'contract'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col">
                <h3>
                    Show All:
                    <input type="checkbox" style="margin:10px;transform: scale(1.5);"
                           [id]="isShowAll" [name]="isShowAll"
                           [checked]="isShowAll"
                           (change)="toggleShowAll()"
                           autocomplete="off" />
                </h3>
            </div>
            <div class="col text-end">
                <button type="button" (click)="refreshOffers()" class="btn btn-success">
                    <span class="fas fa-sync" aria-hidden="true"></span> Refresh
                </button>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div [ngClass]="isEditOpportunityCosts ? 'col-sm-8' : 'col-sm-12'">
        <kendo-grid #offersGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [sortable]="true"
                    [pageable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column field="carrierCode" title="Carrier 3x3" width="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <rmis-status [rmisStatusColor]="dataItem.rmisStatusColor" [rmisStatusTextColor]="dataItem.rmisStatusTextColor" [rmisStatusAbbrev]="dataItem.rmisStatusAbbrev" [rmisStatusTooltip]="dataItem.nonCertifiedReasons"></rmis-status>
                    <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode]">
                        {{dataItem.carrierCode}}
                    </a>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="mcNumber" title="MC #" width="100"></kendo-grid-column>
            <kendo-grid-column field="offerRatePerMile" title="Per Mile" format="{0:c}" width="75"></kendo-grid-column>
            <kendo-grid-column field="offerRate" title="Rate" format="{0:c}" width="75"></kendo-grid-column>
            <kendo-grid-column field="fuelCostPerMile" title="Fuel/mi" format="{0:c}" width="75" *ngIf="viewType == 'RFQ' || viewType == 'contract'"></kendo-grid-column>
            <kendo-grid-column field="fuelCost" title="Fuel" format="{0:c}" width="75" *ngIf="viewType == 'RFQ' || viewType == 'contract'"></kendo-grid-column>
            <kendo-grid-column title="Declined" width="50">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.isDeclined ? 'Yes' : 'No'}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Action" width="200">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button class="btn btn-success" (click)="awardOffer(dataItem)" *ngIf="isAward"
                            [disabled]="isExcludeNonRMISCertified && !dataItem.isRMISCertified && !dataItem.isMexicoOnly && !dataItem.isExcludeRMISCertification">
                        <i class="fas fa-exclamation-circle text-danger" *ngIf="isExcludeNonRMISCertified && !dataItem.isRMISCertified && !dataItem.isMexicoOnly && !dataItem.isExcludeRMISCertification"></i>
                        Award
                    </button>
                    <button class="btn btn-success m-1" (click)="setContract(dataItem)" *ngIf="viewType == 'contract'">Set Contract</button>
                    <button class="btn btn-secondary m-1" (click)="sendOfferEmail(dataItem)" *ngIf="viewType != 'contract'">Email Offer</button>
                    <button class="btn btn-danger" (click)="deleteOffer(dataItem)" *ngIf="viewType != 'contract'">Delete Offer</button>
                    <div class="text-danger" *ngIf="isExcludeNonRMISCertified && !dataItem.isRMISCertified && !dataItem.isMexicoOnly && !dataItem.isExcludeRMISCertification">
                        <i class="fas fa-exclamation-circle"></i>
                        Not RMIS Certified
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="opportunityCosts" title="Opportunity Costs" width="100" *ngIf="viewType == 'RFQ' || viewType == 'contract'">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-secondary" *ngIf="canEditOpportunityCosts(dataItem.offerID)" (click)="editOpportunityCosts(dataItem.offerID)">Set Costs</button>
                    {{dataItem.opportunityCosts}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="createdByEmployeeName" title="Entered By" width="100"></kendo-grid-column>
            <kendo-grid-column field="transactionDate" title="Entered Date" width="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.transactionDate == '' ? '' : dataItem.transactionDate | date: 'M/dd/yy HH:mm'}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Comment" class="text-nowrap" width="400">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <!--<input type="text" class="p-2" [value]="dataItem.notes" [(ngModel)]="dataItem.notes" />-->
                    <!--<textarea rows="{{dataItem.commentText != null ? 1+dataItem.commentText.length/75 : 1 | number:'1.0-0'}}" cols="75" [(ngModel)]="dataItem.notes"></textarea>-->
                    <kendo-textarea style="width:90%" id="comment"
                                    resizable="auto"
                                    [(ngModel)]="dataItem.commentText"
                                    [value]="dataItem.commentText">
                    </kendo-textarea>
                    <i class="fas fa-save fa-2x m-1 text-success" (click)="leaveComment(dataItem)"></i>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-4" *ngIf="isEditOpportunityCosts">
        <kendo-expansionpanel [title]="'Opportunity Costs'"
                              [subtitle]=""
                              [expanded]="true">
            <div *ngIf="availableOpportunityCostTypeList.length == 0">
                <label class="fw-bold text-danger">No opportunity cost types available</label>
            </div>
            <div class="row" *ngFor="let cost of availableOpportunityCostTypeList">
                <div class="col-sm-1">
                    <input type="checkbox" style="margin:5px;transform: scale(1.5);"
                           id="cost{{ cost.opportunityCostTypeID }}"
                           name="cost{{ cost.opportunityCostTypeID }}"
                           (change)="setOpportunityCost(cost.opportunityCostTypeID)"
                           [checked]="checkIsUsedForCost(cost.opportunityCostTypeID)"
                           autocomplete="off" />
                </div>
                <div class="col-sm-10">
                    <label for="cost{{ cost.opportunityCostTypeID }}">{{ cost.description }}</label>
                </div>
            </div>
            <button type="button" class="btn btn-secondary" (click)="cancelEdit()">Close</button>
        </kendo-expansionpanel>
    </div>
</div>
